const state = {
  authentication: false,
  login: false,
  register: false,
  leftDrawer: true,
  tooltips: false,

  is_verified: false,
  is_loading: false,

  // components
  componentInitError: false,

  // ****************** INVOICE
  invoiceAddDialog: false, //v2
  invoiceTemplateDialog: false, //v2
  invoiceItemTaxDialog: false,
  invoiceItemFeeDialog: false,
  invoiceItemDiscountDialog: false,
  invoiceTaxDialog: false,
  invoiceFeeDialog: false,
  invoiceDiscountDialog: false,
  invoiceAddItemDialog: false,
  invoiceEmailEditor: false,
  invoiceTemplateEmailEditor: false,

  // ****************** BILLING
  recurringApp: false,
  // RECURRING PLAN
  billingrecurringTemplateDetailDialog: false,
  billingRecurringTemplateEditDialog: false,
  billingRecurringTemplateScheduleViewDialog: false,
  billingRecurringTemplateCreatedDialog: false,
  billingRecurringTemplateSendEmailDialog: false,
  billingRecurringTemplateEmailWelcomeDialog: false,
  BillingRecurringmailEditorFullDialog: false,
  baseSettingsBillingRecurringTemplateDialog: false,
  billingRecurringTemplateTokensDialog: false,
  billingRecurringTemplateCustomerEditDialog: false,
  billingRecurringTemplateCustomerAddDialog: false,

  // RECURRING TEMPLATE
  billingRecurringTemplateDetailDialog: false, //
  billingRecurringTemplateArchiveDialog: false,
  billingRecurringTemplateScheduleDialog: false,
  billingRecurringTemplatePlanDetailDialog: false,

  // BILLING
  billingInvoiceShowDetail: false,
  billingInvoiceDetailDialog: false,
  billingInvoiceCreateDialog: false,
  billingInvoiceEditDialog: false,
  billingAnvoiceArchiveDialog: false,
  billingInvoiceSendEmailDialog: false,
  billingInvoiceDetailDialogFull: false,
  billingInvoiceIssueDialog: false,
  billingInvoiceAddressDialog: false,
  billingMailCreateDialog: false,

  billingScheduleMakePaymentDialog: false,
  billingScheduleEditDialog: false,
  billingSchedulePaymentListDialog: false,
  billingScheduleTransactionsCardListDialog: false,
  billingSchedulePaymentListSendEmail: false,
  billingScheduleTransactionSuccess: false,

  // FORM TEMPLATE

  formTemplateModalDialog: false,
  formTemplateModalFullDialog: false,
  formTemplateEmailDialog: false,
  formTemplateEmailFullDialog: false,
  formTemplateBuilderLeftDrawer: true,
  formTemplateBuilderDesktopMode: true,
  formTemplateBuilderPreviewMode: false,

  formTemplateEditDialog: false,
  formTemplateArchiveDialog: false,
  formTemplateAddressDetailDialog: false,
  formTemplateLinkDetailDialog: false,
  formTemplateCartDialog: false,
  formTemplateShippingDetailDialog: false,

  // REDIRECT
  formTemplateRedirectDialog: false,
  formTemplateRedirectFullDialog: false,
  formRedirectReviewDialog: false,
  formRedirectDialog: false,
  formRedirectFullDialog: false,

  // FORM 
  formTemplateInvoiceDialog: false,
  formTemplateInvoiceFullDialog: false,
  formInvoiceReviewDialog: false,
  formInvoiceDialog: false,
  formInvoiceFullDialog: false,

  // EMBEDDED
  formEmbeddedTemplateDetailDialog: false,

  // FORM

  formModalDialog: false,
  formModalFullDialog: false,
  formEmailDialog: false,
  formEmailFullDialog: false,

  formShowStyler: false,

  formEditDialog: false,
  formArchiveDialog: false,
  formAddressDetailDialog: false,
  formPolicyDetailDialog: false,
  formCartDialog: false,

  formCheckoutTermsDialog: false,
  formLinkDialog: false,

  // ************************ EMAILS
  baseEmailDetailDialog: false,
  emailDeleteDialog: false,

  // ***************************** MAIL
  mailApp: false,
  mailEditorFullDialog: false,
  mailSendMailDialogFull: false,

  mailDetailDialog: false,
  mailEditorDrawer: false,
  mailPreviewDialog: false,
  mailHtmlViewDialog: false,
  mailTemplateDetailDialog: false,
  mailTemplateEditorDrawer: false,

  mailTemplatePageForm: false,
  mailTemplateHeroForm: false,
  mailTemplateTitleForm: false,
  mailTemplateContentForm: false,
  mailTemplateButtonForm: false,
  mailTemplateClosingForm: false,
  mailTemplateBrandForm: false,

  // ******************************* NOTIFICATION
  formEmailCreateDialog: false,

  // ****************** PRODUCT
  productApp: false,
  productCartApp: false,
  productDetailDialog: false,
  productCostDetailDialog: false,

  productTaxDialog: false,
  productFeeDialog: false,
  productDiscountDialog: false,
  productCartCostDialog: false,
  productCartTaxDialog: false,
  productCartFeeDialog: false,
  productCartDiscountDialog: false,
  productArchiveDialog: false,

  // ********************************* BASE

  // STYLE
  baseThemeDetailDialog: false,

  // SETTINGS
  baseSettingsFullDialog: false,
  baseSettingsFullMaximize: true,

  baseSettingsBillingRecurringTabsDialog: false,
  baseSettingsBillingInvoiceDetailDialog: false,
  baseSettingsBillingScheduleDialog: false,
  baseSettingsBillingRecurringDialog: false,

  cartSettingsDialog: false,
  cartSettingsMetaDialog: false,
  cartSettingsCustomDialog: false,

  recurringSettingsMetaDialog: false,
  recurringSettingsCustomDialog: false,
  recurringSettingsDialog: false,

  baseSettingsAddressDialog: false,
  baseSettingsFormDialog: false,
  baseSettingsFormTabsDialog: false,
  baseSettingsFormRedirectDetailDialog: false,
  baseSettingsFormInvoiceDetailDialog: false,
  baseSettingsFormModalDetailDialog: false,
  baseSettingsFormEmbeddedDetailDialog: false,
  baseSettingsFormEmailDetailDialog: false,
  baseSettingsProductDialog: false,
  baseSettingsdetailDialog: false,
  baseSettingsContactDialog: false,
  baseSettingsCompanyDialog: false,
  baseSettingsTenantDialog: false,

  baseSettingsTaxDialog: false,
  baseSettingsFeeDialog: false,
  baseSettingsDiscountDialog: false,

  baseErrorPersistentDialog: false,
  baseNotesDialog: false,

  // ADDRESS
  baseAddressDetailDialog: false,
  baseAddressMapDialog: false,
  baseAddressDeleteDialog: false,
  baseAddressNotesDialog: false,

  // PHONE
  basePhoneDetailDialog: false,
  basePhoneDeleteDialog: false,

  // POLICY
  baseLinksDetailDialog: false,

  // *********************** NOTES
  baseNoteslDialog: false,

  // *********************** SHIPPING
  baseShippingOptionDetailDialog: false,

  show_bank_detail: false,
};

const getters = {};

const mutations = {};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
